import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import dateSort from 'scaleflow/utils/dateSort';

export default class BacklogInitiativesInitiativeArtifactsController extends Controller {
  @service store;
  @service currentUser;

  queryParams = ['search'];
  @tracked search = '';

  get artifacts() {
    let artifacts = (this.store.peekAll('artifact') ?? [])
      .filter(
        (artifact) =>
          artifact.initiative.get('id') === this.model.initiative.id,
      )
      .toSorted((a, b) => dateSort(a.created_at, b.created_at, 'desc'));
    if (this.search) {
      artifacts = artifacts.filter(this.isAMatchCallback);
    }
    return artifacts;
  }

  @action
  deleteArtifact(artifact) {
    artifact.destroyRecord();
  }

  get isAMatchCallback() {
    if (!this.search) return () => true;
    return (artifact) => {
      return (artifact.name ?? '')
        .toLowerCase()
        .includes(this.search.toLowerCase());
    };
  }

  @action
  createArtifact() {
    const artifact = this.store.createRecord('artifact', {
      name: 'New Artifact',
      content: '***MARKDOWN CONTENT***',
      initiative: this.model.initiative,
      created_by: {
        type: 'PERSON',
        id: this.currentUser.id,
      },
    });
    artifact.save();
  }
}
